/**
 * Checks for valid response
 * @param response
 */
import {WriterError} from '../../error/WriterError'
import {ErrorCodes} from '../../constants/ErrorCodes'

const getParams = function({statusText, status}) {
    return {
        statusText,
        status
    }
}

/**
 *
 * @param response
 * @param codeConversions
 * @throws {WriterError}
 * @returns {Object}
 */
const assertResponse = function(response, codeConversions = {}) {
    if (typeof response !== 'object') {
        throw new WriterError(ErrorCodes.APPLICATION, new Error('The fetch response is of unknown type'), {})
    }

    if (codeConversions[response.status]) {
        throw new WriterError(
            codeConversions[response.status],
            new Error(response.statusText),
            getParams(response))
    }

    if (response.status < 200 || response.status >= 300) {
        throw new WriterError(ErrorCodes.GENERAL_COMMUNICATION, new Error(response.statusText), getParams(response))
    }

    return response
}

export {assertResponse}
